export default __webpack_public_path__ + "static/media/Trevor_Allen_Resume.6fe83289.pdf";